import { ReferanceAsyncSelect } from './referance-async-select'

export function SelectReferanceCode4HomeInner({ name }) {
  return (
    <ReferanceAsyncSelect
      name={name}
      label=""
      labelCategory="SALLANTI KARTI HOME"
      valueField="code"
    />
  )
}
